import React, { useState } from 'react';
import './applypage.css';
import { db, storage } from '../../config/firebase';
import { addDoc, collection } from 'firebase/firestore';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { useLocation } from 'react-router-dom';

const ApplyPage = () => {
    const location = useLocation();
    const { volunteerOpportunity } = location.state || {}; // Get the volunteerOpportunity from the state

    const [volunteerName, setVolunteerName] = useState('');
    const [email, setEmail] = useState('');
    const [cellNo, setCellNo] = useState('');
    const [cv, setCv] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [applicationCode, setApplicationCode] = useState('');

    const generateApplicationCode = (position) => {
        const prefix = position.slice(0, 3).toUpperCase();
        const uniqueNumber = Math.floor(1000 + Math.random() * 9000);
        return `${prefix}-${uniqueNumber}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!cv) {
            alert('Please upload your CV.');
            return;
        }
        setIsSubmitting(true);

        try {
            // Upload CV to Firebase Storage
            const storageRef = ref(storage, `cvs/${cv.name}`);
            const uploadTask = uploadBytesResumable(storageRef, cv);

            // Await for the upload to finish and get the download URL
            uploadTask.on('state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log(`Upload is ${progress}% done`);
                },
                (error) => {
                    console.error('Upload failed:', error);
                    alert('There was an error uploading your CV. Please try again.');
                    setIsSubmitting(false);
                },
                async () => {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    console.log('CV uploaded successfully. Download URL:', downloadURL);

                    // Generate application code
                    const applicationCode = generateApplicationCode(volunteerOpportunity.title);
                    setApplicationCode(applicationCode);

                    // Add application details to Firestore with initial status
                    await addDoc(collection(db, 'volunteerApplications'), {
                        volunteerName,
                        email,
                        cellNo,
                        position: volunteerOpportunity.title,
                        code: applicationCode,
                        cvUrl: downloadURL,
                        opportunityId: volunteerOpportunity.id || 'N/A',
                        submittedAt: new Date(),
                        status: 'Application Received'
                    });

                    alert('Your application has been submitted! Your application code is ' + applicationCode);
                    setVolunteerName('');
                    setEmail('');
                    setCellNo('');
                    setCv(null);
                    setIsSubmitting(false);
                }
            );
        } catch (error) {
            console.error('Error submitting application:', error);
            alert('There was an error submitting your application. Please try again.');
            setIsSubmitting(false);
        }
    };

    if (!volunteerOpportunity) {
        return <div>Opportunity data is missing.</div>;
    }

    return (
        <div className="apply_container">
            <h1>Apply for {volunteerOpportunity.title}</h1>
            <form onSubmit={handleSubmit}>
                <label htmlFor="name" className='label_tag'>Name:</label>
                <input type="text" placeholder='Your name' required className='input_tag' value={volunteerName} onChange={e => setVolunteerName(e.target.value)} />

                <label htmlFor="email" className='label_tag'>Email:</label>
                <input type="email" placeholder='Your email' required className='input_tag' value={email} onChange={e => setEmail(e.target.value)} />

                <label htmlFor="cellno" className='label_tag'>Cell NO:</label>
                <input type="text" placeholder='Cell number' required className='input_tag' value={cellNo} onChange={e => setCellNo(e.target.value)} />

                <label htmlFor="cv" className='label_tag'>Upload CV:</label>
                <input type="file" className='input_tag' onChange={(e) => setCv(e.target.files[0])} required />

                <button className='form_btn' type="submit" disabled={isSubmitting}>Submit</button>
            </form>
            {applicationCode && (
                <div className='application_code'>
                    <h2>Your Application Code</h2>
                    <p>{applicationCode}</p>
                    <p>Please save this code to track your application status.</p>
                </div>
            )}
        </div>
    );
}

export default ApplyPage;
